module.exports = __webpack_public_path__ + "static/beach-f07c5367f60b7d338c25fbacf3fef355.jpg";